import * as z from "zod";

export const BOOK_PATH_PREFIX = "/api/book/";
export const BOOK_AFFILIATE_PARAM = "aff";

export const bookPath = (sku: string, affiliateId: string): string =>
  `${BOOK_PATH_PREFIX}${encodeURIComponent(sku)}?${BOOK_AFFILIATE_PARAM}=${encodeURIComponent(affiliateId)}`;

const safeString = z
  .string()
  .refine((s) => !/<[^>]*>/i.test(s), "Must not contain HTML tags");

export const BOOKSHOP_HOST = "bookshop.org";

export function isBookshopHost(hostname: string): boolean {
  return hostname === BOOKSHOP_HOST || hostname.endsWith(`.${BOOKSHOP_HOST}`);
}

// z.url() alone admits javascript: and data:, and these land in href/src.
const httpsUrl = z.url({ protocol: /^https$/ });
const bookshopUrl = httpsUrl.refine(
  (value) => isBookshopHost(new URL(value).hostname),
  "Must be a bookshop.org URL",
);

export const bookDataSchema = z.object({
  title: safeString,
  author: safeString,
  imageUrl: httpsUrl,
  listPrice: safeString,
  salePrice: safeString,
  affiliateUrl: bookshopUrl,
  affiliateInfo: z
    .object({ name: safeString, logoUrl: httpsUrl.optional() })
    .optional(),
});
export type BookData = z.infer<typeof bookDataSchema>;
